export enum VARIANT_COLOR_TAGS {
  DEFAULT = 'default',
  SECONDARY = 'secondary',
  DEFAULT_INVERSE = 'default--inverse'
}
